import { render } from "./InputOverridePrice.vue?vue&type=template&id=1b133d0c&scoped=true"
import script from "./InputOverridePrice.vue?vue&type=script&lang=js"
export * from "./InputOverridePrice.vue?vue&type=script&lang=js"

import "./InputOverridePrice.vue?vue&type=style&index=0&id=1b133d0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b133d0c"]])

export default __exports__